﻿import $ from "jquery";
import { SortElement } from "./SortElement";
export class GuiFilterSortClient {

    inputDirection: JQuery<HTMLElement>;
    inputColumnName: JQuery<HTMLElement>;
    erzDetailList: JQuery<HTMLElement>;
    head: JQuery<HTMLElement>;
    body: JQuery<HTMLElement>;

    private readonly attachRowEvents: (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => void;

    spanDown = "<i class='fa fa-sort-alpha-down' style='margin-left: 5px;margin-right: 5px;'></i>";
    spanUp = "<i class='fa fa-sort-alpha-up' style='margin-left: 5px;margin-right: 5px;'></i>";


    constructor(public divList: JQuery, attacheRowEvents: (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => void) {

        this.attachRowEvents = attacheRowEvents; // Handler von Liste übergeben, um nach Paging spezielle Events anzuhängen
        this.erzDetailList = divList;

        this.head = $("div.erz-list-header", this.erzDetailList);
        this.body = $("div.erz-clientlist-body", this.erzDetailList);
        const fieldColumnName = this.head.data("field-columnname");
        const fieldDirection = this.head.data("field-direction");
        this.inputColumnName = $(`#${fieldColumnName}`);
        this.inputDirection = $(`#${fieldDirection}`);

        this.showSort(this.inputColumnName.val() as string, this.inputDirection.val() as string);
        $("div.erz-list-header *[data-sort-name-client]", this.divList).on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => { this.clickClientSort(e); });
    }


    showSort(columnName: string, direction: string) {
        // Anzeige sort
        $(`[data-sort-name-client] svg`, this.head).remove();
        const th = $(`[data-sort-name-client='${columnName}']`, this.head);
        th.data("sort-direction", direction);
        if (direction === "asc")
            th.append($(this.spanDown));
        else
            th.append($(this.spanUp));
    }

    private clickClientSort(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        console.log("clickClientSort");

        const columnNameElement = $(e.currentTarget);

        const columnName = columnNameElement.data("sort-name-client");

        // Direction ermitteln
        let direction = columnNameElement.data("sort-direction");
        if (direction === "asc") {
            direction = "desc";
        } else {
            direction = "asc";
        }

        // Speichern Sort an der Spalte
        columnNameElement.data("sort-direction", direction);

        // Anzeige sort
        this.showSort(columnName, direction);

        // Alle Element in der Liste mit der Column Verbindung
        const eleSortBase = this.body.find(`*[data-sort-name-client='${columnName}']`);

        // Sortierarray aufbauen
        let list = new Array<SortElement>();
        eleSortBase.each((index, element) => {
            const v = $(element).data("sort-value");
            const row = $(element).closest("div.erz-list-element");

            const sortElement = {
                Row: row,
                Value: v,
            } as SortElement;

            list.push(sortElement);
        });

        // Sortierung des Arrays
        const comparer = direction === "asc" ? -1 : 1;
        list = list.sort((a: SortElement, b: SortElement) => {
            if (a.Value === b.Value) return 0;
            if (a.Value > b.Value)
                return 1 * comparer;
            else
                return -1 * comparer;
        });

        // Body entfernen und neu aufbauen
        this.body.empty();
        list.forEach((value) => {
            this.body.append(value.Row);
        });

        // Klick Events wieder anhängen
        // Element in Liste, kein Button 
        $("div.erz-list-element > div", this.divList).not(".col-button").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => { this.attachRowEvents(e); });

        // Sort an Form übergeben
        this.inputColumnName.val(columnName);
        this.inputDirection.val(direction);

    }


}
